import type { FC, SVGProps } from "react"

const FooterX: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.7512 1.25H18.5737L12.2537 8.51L19.6662 18.75H13.8287L9.26367 12.9275L4.08617 18.75H1.26117L8.03367 10.9775L0.916172 1.25H6.90867L11.0212 6.5525L15.7512 1.25ZM14.7512 17.025H16.3037L5.90117 2.8775H4.23617L14.7512 17.025Z"
      fill="#8B8987"
    />
  </svg>
)

export default FooterX
